<div class="mb-12 w-full h-full" [class.disabled]="disabled">
  <div class="scroller w-full h-full">
    <div class="attachments gap-wrapper w-full h-full">
      <div class="attachment w-full h-full" *ngIf="attachment$ | async as attachment" (click)="openSlider(attachment.url)">
        <div class="no-overflow w-full h-full custom-media">
          <ui-media-preview [fileUrl]="attachment.url"></ui-media-preview>
        </div>

        <ion-button color="danger" (click)="removeAttachment()" class="close" *ngIf="!readonly">
          <ion-icon name="close-outline" size="big"></ion-icon>
        </ion-button>
      </div>

      <ion-button
        #placeholder
        class="placeholder m-0 w-full h-full"
        color="medium"
        fill="clear"
        (click)="uploader.click()"
        *ngIf="(attachment$ | async) === null"
        [disabled]="readonly || disabled"
      >
        <div class="ion-flex-column ion-align-items-center ion-justify-content-center gap-4">
          <ion-icon *ngIf="!disabled" name="add-circle-outline"></ion-icon>
          <ion-icon *ngIf="disabled" name="close-circle-outline"></ion-icon>
          <span class="ion-text-uppercase">{{ label ?? 'upload-file' | translate }}</span>
        </div>
      </ion-button>

      <input
        #uploader
        data-cy="Attachment"
        class="hidden"
        type="file"
        accept="image/*,.pdf"
        (change)="onChangeAttachment($event)"
        required
      />
    </div>
  </div>
</div>
